/** Set when Google Sheets status is `connected` or `pending-link` (middleware-readable). */
export const GOOGLE_SHEETS_CONNECTED_COOKIE = "aera_google_sheets_connected";
